import { render, staticRenderFns } from "./recommendationCreate.vue?vue&type=template&id=5ca4a4b0&"
import script from "./recommendationCreate.vue?vue&type=script&lang=js&"
export * from "./recommendationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports